import { status } from 'skin/event/status';
import finish from './finish';

const master = (obj, ms, story, data, d, action) => {
	switch (obj.action) {
		case 'finish':
			return finish(obj, ms, story, data, d, action);
		default:
			return status.action;
	}
};

export default master;
